import React from 'react';
import { Col, Row } from 'react-bootstrap';

export const ServiceSection = ({ title, text, image, techImages }) => {

	const getTechImages = () => {
		return techImages.map(el =>
			<Col key={el.techName} style={{ display: 'inline-block', marginRight: '20px', marginTop: '15px' }}
			     className="text-center ">
				<img src={require('../../../assets/images/services')[el.image]} alt={el.techName}
				     className="tech-image" />
			</Col>
		);
	};

	return (
		<Col md={6} style={{ marginBottom: '60px' }}>
			<div className="inner-box wow fadeInDown">
				<Row>
					<Col md={3} sm={4} xs={12} className="text-center">
						<img style={{ width: '200px' }} src={require('../../../assets/images/services')[image]}
						     alt={title} />
					</Col>

					<Col md={9} sm={8} xs={12}>
						<div>
							<h3>{title}</h3>
							<div className="text">{text}</div>

							<div>
								{getTechImages()}
							</div>
						</div>
					</Col>
				</Row>
			</div>
		</Col>
	);
};



// WEBPACK FOOTER //
// ./src/components/ui/Services/ServiceSection.js